/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import Axios from 'axios';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from 'react-router-dom-latest';
import Interweave from 'interweave';
import TooltipItem from 'common/TooltipItem';
import NoRecords from 'common/NoRecords';
import { withRouter } from 'utilities/withRouterWrapper';
import { sortingIcon, AlertMessage } from 'utilities/utils';
import {
  CUSTOM_TEMPLATES,
  UPDATE_TEMPLATES_SORT_ORDER,
} from 'constants/constants';
import ConfirmationModal from 'common/ConfirmationModal';

const sortList = (data, sortBy, sortOrder) => {
  let listData = data;
  listData.sort((a, b) => {
    let x = a.sort_order;
    let y = b.sort_order;
    if (sortBy === 'name') {
      x = a.name.toLowerCase();
      y = b.name.toLowerCase();
    } else if (sortBy === 'attachment') {
      x = a.no_of_files;
      y = b.no_of_files;
    }
    if (x < y) {
      return -1;
    }
    return 1;
  });
  if (sortOrder === 'desc') {
    listData = listData.reverse();
  }
  return data;
};

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const messageTemplateHeaders = [
  {
    value: 'name',
    label: 'Subject',
    isSortable: true,
    className: ' col-2 thCol',
  },
  {
    value: 'content',
    label: 'Description',
    isSortable: false,
    className: ' col-4 thCol',
  },
  {
    value: 'documents',
    label: 'Attachment?',
    isSortable: false,
    className: ' col-2 thCol',
  },
  {
    value: 'sort_order',
    label: 'Sort Order',
    isSortable: true,
    className: ' col-2 thCol',
  },
];

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',

  // change background colour if dragging
  background: isDragging ? '#dfe3e8' : 'white',
  borderRadius: isDragging && '8px',
  // borderTop: isDragging ? '' : '0.5px solid #dfe3e8',
  // borderBottom: isDragging ? '' : '0.5px solid #dfe3e8',
  color: isDragging ? '#00aecc !important' : '',
  ...draggableStyle,
});

const getItemCssClass = (isDragging) => {
  if (isDragging) {
    return 'tdBtn dragable_row';
  }
  return 'tdBtn';
};

class TemplatesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      listData: [],
      sortBy: 'sort_order',
      sortOrder: 'asc',
      showDeleteConfirmation: false,
      errorMessages: [],
      defaultPreferences: true,
      searchResults: [],
      searchFieldText: '',
      showDeleteErrorMessage: false,
      templateTypes: 'message',
    };
  }

  componentDidMount() {
    this.getRecords();
  }

  getRecords = () => {
    const { sortBy, sortOrder, searchFieldText } = this.state;
    const { type } = this.props;
    let url = `${CUSTOM_TEMPLATES}?template_type=${type}`;
    if (searchFieldText && searchFieldText !== null && searchFieldText.length) {
      url = `${url}&search=${searchFieldText}`;
    }
    Axios.get(url)
      .then((res) => {
        if (res.data && res.data.data && res.data.data.length) {
          const { data, default_preferences } = res.data;
          this.setState({
            listData: sortList(data, sortBy, sortOrder),
            loading: false,
            defaultPreferences: default_preferences,
          });
        } else {
          this.setState({
            listData: undefined,
            loading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          listData: undefined,
          loading: false,
        });
      });
  };

  handleSorting = (sortBy) => {
    let { sortOrder } = this.state;
    let { listData } = this.state;
    if (this.state.sortBy === sortBy) {
      if (sortOrder === 'asc') {
        sortOrder = 'desc';
      } else {
        sortOrder = 'asc';
      }
    } else {
      sortOrder = 'asc';
    }
    listData.sort((a, b) => {
      let x = a.sort_order;
      let y = b.sort_order;
      if (sortBy === 'tag_name') {
        x = a.key.toLowerCase();
        y = b.key.toLowerCase();
      } else if (sortBy === 'no_of_files') {
        x = a.no_of_files;
        y = b.no_of_files;
      }
      if (x < y) {
        return -1;
      }
      return 1;
    });
    if (sortOrder === 'desc') {
      listData = listData.reverse();
    }
    this.setState({
      sortOrder,
      sortBy,
      listData: sortList(listData, sortBy, sortOrder),
    });
  };

  toggleInput = (index) => {
    const { listData } = this.state;
    this.props.navigate(`/templates/${listData[index].id}`);
  };

  deleteTag = () => {
    const { recordtoDelete } = this.state;
    this.setState({
      loading: true,
      showDeleteConfirmation: false,
    });
    if (recordtoDelete) {
      Axios.delete(`${CUSTOM_TEMPLATES}/${recordtoDelete.id}`).then((res) => {
        if (res.data) {
          const { status, message } = res.data;
          if (status === 200) {
            AlertMessage('success', message, 3000);
          } else {
            AlertMessage('error', message, 5000);
          }
          this.getRecords();
        }
      });
    }
  };

  handleDragEnd = (result) => {
    if (
      !result.destination ||
      result.destination.index === result.source.index
    ) {
      return;
    }

    const listData = reorder(
      this.state.listData,
      result.source.index,
      result.destination.index,
    );
    listData.map((e, index) => {
      e.sort_order = index + 1;
      return e;
    });
    this.setState(
      {
        listData,
        loading: this.state.defaultPreferences,
      },
      () => {
        const { type } = this.props;
        const templates_id = [];
        listData.map((e) => {
          templates_id.push(e.id);
          return e;
        });
        Axios.post(UPDATE_TEMPLATES_SORT_ORDER, {
          templates_id,
          template_type: type,
        }).then((res) => {
          if (res.data) {
            const { status, message } = res.data;
            if (status === 200) {
              AlertMessage('success', message, 3000);
              if (this.state.defaultPreferences) {
                this.getRecords();
              } else {
                this.setState({ loading: false });
              }
            } else {
              AlertMessage('error', message, 3000);
            }
          }
        });
      },
    );
  };

  toggleDeleteConfirmation = (input = {}) => {
    this.setState({
      recordtoDelete: input,
      showDeleteConfirmation: !this.state.showDeleteConfirmation,
      deleteErrorMessage: undefined,
    });
  };

  toggleErrorMessage = () => {
    this.setState({
      showDeleteErrorMessage: !this.state.showDeleteErrorMessage,
    });
  };

  handleSearch = (input) => {
    const inputvalue = input && input.target.value ? input.target.value : '';
    this.setState({ searchFieldText: inputvalue });
    clearTimeout(this.typingTime);
    this.typingTime = setTimeout(() => {
      this.getRecords();
    }, 500);
  };

  render() {
    const {
      sortBy,
      sortOrder,
      loading,
      showDeleteConfirmation,
      recordtoDelete,
      currentIndex,
      errorMessages,
      searchFieldText,
      listData,
    } = this.state;
    return (
      <div id="content">
        {loading ? (
          <div id="loading" role="status" aria-label="Loading templates" />
        ) : null}
        <div className="center-wrapper">
          <div className="filter-wrapper d-flex justify-content-between align-items-center">
            <div className="filterPart d-flex">
              <div className="form-group has-search">
                <span className="icon-zoom2 form-control-feedback" />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Template"
                  id="tag-search"
                  onChange={this.handleSearch}
                  value={searchFieldText}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="FilterHeader--Action align-self-start">
              <Link
                to={`/templates/new?type=${this.props.type}`}
                className="btn btn-primary"
              >
                + Template
              </Link>
            </div>
          </div>
          {listData === undefined ? <NoRecords /> : null}
          {listData !== undefined && listData !== null && listData.length ? (
            <section>
              {errorMessages.map((e, index) => (
                <div
                  className="alert alert-danger alert-dismissible align-items-center pl-3 pr-1 pt-2 pb-2"
                  role="alert"
                >
                  {/* <Interweave allowAttributes content={e} /> */}
                  <Interweave allowAttributes content={e.message} />
                  <button
                    type="button"
                    className="btn-sm btn--onlyicon btn-link"
                    aria-label="Close Alert"
                    onClick={() => this.toggleErrorMessage(index)}
                  >
                    <i className="icon-close2" aria-hidden="true" />
                  </button>
                </div>
              ))}
              <div className="tab-content">
                <div className="tab-pane active">
                  <DragDropContext onDragEnd={this.handleDragEnd}>
                    <table id="tags_list" className="tableWrap col">
                      <thead className="tRow tRow--head">
                        <tr className="row">
                          {messageTemplateHeaders.map((each) => (
                            <th
                              key={each.value}
                              className={
                                sortingIcon(
                                  sortBy,
                                  each.value,
                                  sortOrder,
                                  'className',
                                ) + each.className
                              }
                              onClick={() =>
                                each.isSortable
                                  ? this.handleSorting(each.value)
                                  : null
                              }
                            >
                              <span className="posRel">
                                {each.label}
                                <i
                                  className={sortingIcon(
                                    sortBy,
                                    each.value,
                                    sortOrder,
                                  )}
                                />
                              </span>
                            </th>
                          ))}
                          <td className="col thCol" />
                        </tr>
                      </thead>
                      <Droppable droppableId="tags">
                        {(droppable_provided) => (
                          <tbody
                            className="tRow tRow--body"
                            {...droppable_provided.droppableProps}
                            ref={droppable_provided.innerRef}
                          >
                            {listData.map((each, index) => (
                              <Draggable
                                key={each.id}
                                draggableId={each.id.toString()}
                                index={index}
                                isDragDisabled={
                                  !(
                                    sortBy === 'sort_order' &&
                                    sortOrder === 'asc'
                                  ) ||
                                  currentIndex !== undefined ||
                                  searchFieldText.length > 0
                                }
                              >
                                {(provided, snapshot) => (
                                  <tr
                                    key={each.id}
                                    className={getItemCssClass(
                                      snapshot.isDragging,
                                      provided.draggableProps[
                                        'data-rbd-draggable-id'
                                      ],
                                      each.key,
                                    )}
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                      snapshot.isDragging,
                                      provided.draggableProps.style,
                                    )}
                                  >
                                    <td className="col-2 tdCol text-body">
                                      <span>
                                        {each.name && each.name !== null
                                          ? each.name
                                          : each.description}
                                      </span>
                                    </td>
                                    <td className="col-4 tdCol text-body">
                                      <span>
                                        {' '}
                                        <Interweave
                                          allowAttributes
                                          content={each.content}
                                        />
                                      </span>
                                    </td>
                                    <td className="col-2 tdCol text-body">
                                      <Link
                                        to={`/files?tags=${encodeURIComponent(
                                          each.key,
                                        )}`}
                                        className="text-body"
                                      >
                                        {each.documents &&
                                        each.documents !== null &&
                                        each.documents !== '0'
                                          ? 'Y'
                                          : 'N'}
                                      </Link>
                                    </td>
                                    <td className="col-2 tdCol text-body">
                                      <span>{each.sort_order}</span>
                                    </td>
                                    <td className="col tdCol text-right">
                                      {sortBy === 'sort_order' &&
                                      sortOrder === 'asc' ? (
                                        <OverlayTrigger
                                          key={each.id}
                                          placement="top"
                                          overlay={
                                            <Tooltip id={`dragbutton${index}`}>
                                              Drag to Change Sort Order
                                            </Tooltip>
                                          }
                                        >
                                          <span
                                            id={`dragbutton${index}`}
                                            className="btn-sm btn--onlyicon btn-link tdBtn__hover dragbutton"
                                            style={{ border: '3px' }}
                                          >
                                            <i className="icon-double-arrow" />
                                          </span>
                                        </OverlayTrigger>
                                      ) : (
                                        <Button
                                          type="button"
                                          className="btn-sm btn--onlyicon btn-link tdBtn__hover icon-double-arrow"
                                          disabled
                                        />
                                      )}
                                      <TooltipItem
                                        position="top"
                                        tooltipType="button"
                                        key={`edit${each.id}`}
                                        text="Edit"
                                        btnClass="btn-sm btn--onlyicon btn-link tdBtn__hover"
                                        id={`edit${each.id}`}
                                        clickAction={() =>
                                          this.toggleInput(index)
                                        }
                                        iconn="icon-edit"
                                      />
                                      <TooltipItem
                                        position="top"
                                        tooltipType="button"
                                        key={`delete${each.id}`}
                                        text="Delete"
                                        btnClass="btn-sm btn--onlyicon btn-link tdBtn__hover"
                                        clickAction={() =>
                                          this.toggleDeleteConfirmation(each)
                                        }
                                        id={`delete${each.id}`}
                                        iconn="icon-delete-small"
                                      />
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            ))}
                            {droppable_provided.placeholder}
                          </tbody>
                        )}
                      </Droppable>
                    </table>
                  </DragDropContext>
                </div>
              </div>
            </section>
          ) : null}
          {showDeleteConfirmation ? (
            <ConfirmationModal
              isOpen
              headerText={`Delete the ${recordtoDelete.name} template. Proceed?`}
              yesBtnText="Proceed"
              noBtnText="Cancel"
              yesBtnClick={this.deleteTag}
              noBtnClick={this.toggleDeleteConfirmation}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(TemplatesList);
